/**
 * @class PackagePriceData
 */
export default class PackagePriceData {
    /**
     * @param {Number} id
     * @param {String} displayName
     * @param {Object} surcharge
     */
    constructor(id, displayName, surcharge) {
        this._id = id;
        this._displayName = displayName;
        this._surcharge = surcharge;

        if (this._surcharge === undefined || this._surcharge === null) {
            throw new Error("Price data is null.");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @param {String} displayName
     */
    set displayName(displayName) {
        this._displayName = displayName;
    }

    /**
     * @return {Object}
     */
    get surcharge() {
        return this._surcharge;
    }

    /**
     * @param {Object}  surcharge
     */
    set surcharge(surcharge) {
        this._surcharge = surcharge;
    }
}
